import api from 'utils/api';


export default class UserRequest {

  /**
   * 获取用户列表
   * @param page
   * @param size
   * @returns {*}
   */
  static getUsers(exhibitionId, username, telephone, state, registerBeginTime, registerEndTime, ytc, page, size) {
    return api.get('/admin/users', { page, size, exhibitionId,
      userName:username, telephone, state, startTime:registerBeginTime, endTime:registerEndTime, ytc });
  }


  /**
   * 获取用户列表
   * @param page
   * @param size
   * @returns {*}
   */
  static getRecommendUsers(exhibitionId, username, page, size) {
    return api.get('/admin/player-recommend/findByPage', { page, size, exhibitionId,
      username:username });
  }

  /**
   * 获取用户详情
   * @returns {null}
   */
  static getUser(userId){
    return api.get(`/admin/users/${userId}`);
  }

  /**
   * 操作用户提现金额
   * @returns {null}
   */
  static updateAccount(userId,cashOut){
    return api.post(`/admin/accounts/${userId}/operation`,cashOut);
  }


  /**
   * 更新用户状态
   */
  static updateUserStatus(userId,params){
    return api.put(`/admin/users/${userId}/state`,params);
  }

  /**
   * 添加用户
   */
  static addUser(params){
    return api.post(`/admin/users`,params);
  }


  /**
   * 添加推荐选手
   */
  static addRecommendUser(params){
    return api.post(`/admin/player-recommend/add`,params);
  }


  /**
   * 添加推荐选手
   */
  static deleteRecommendUser(userId){
    return api.put(`/admin/player-recommend/delete/${userId}`);
  }


  /**
   * 解绑用户三方登录
   */
  static unBanUserClaim(userId,type){
    return api.delete(`/admin/users/${userId}/claim/${type}`);
  }


  /**
   * 更新用户信息
   */
  static updateUser(userId,params){
    console.log(params)
    return api.put(`/admin/users/${userId}`,params);
  }

  /**
   * 更新推荐用户信息
   */
  static updateRecommendUser(userId,params){
    console.log(params)
    params.id = userId;
    return api.put(`/admin/player-recommend/edit`,params);
  }


}
